export default __webpack_public_path__ + "static/media/logo_invest.02b1aa29.png";